module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-253.7462b623.svg";